/* eslint-disable react/no-danger */
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Accordion } from "react-bootstrap";
import { AccordionToogle } from "./AccordionToggle";

export function AdditionalInfoCollapsible(props: { text: string, detail : string, addClassName? : string }) {

  return <Accordion defaultActiveKey="0">
    <AccordionToogle eventKey="1">
      <span className={`fakeLink ${props.addClassName}`}>{ props.text } &nbsp;<FontAwesomeIcon icon="question-circle" /></span>
    </AccordionToogle>
    <Accordion.Collapse eventKey="1">
      <div className="portal-help" dangerouslySetInnerHTML={ { __html : props.detail }}></div>
    </Accordion.Collapse>
  </Accordion>;
}
